module.exports = __webpack_public_path__ + "static/img/btn2.c78e594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/btn2.png
// module id = 9KKS
// module chunks = 0